import React from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import DOMPurify from "dompurify";

interface SmartProgramPreviewProps {
	previewHtml: string;
	onApprove: () => void;
	onRegenerate: () => void;
	onCancel: () => void;
	isApproving?: boolean;
}

const SmartProgramPreview: React.FC<SmartProgramPreviewProps> = ({
	previewHtml,
	onApprove,
	onRegenerate,
	onCancel,
	isApproving,
}) => {
	const sanitizedHtml = DOMPurify.sanitize(previewHtml, {
		ALLOWED_TAGS: [
			"div",
			"span",
			"p",
			"h1",
			"h2",
			"h3",
			"h4",
			"h5",
			"h6",
			"ul",
			"ol",
			"li",
			"table",
			"thead",
			"tbody",
			"tr",
			"th",
			"td",
			"strong",
			"em",
			"br",
			"hr",
			"code",
			"pre",
		],
		ALLOWED_ATTR: ["class", "style"],
	});

	return (
		<Box>
			<Typography variant="subtitle1" sx={{ mb: 2 }}>
				Generated Configuration Preview
			</Typography>
			<Paper
				variant="outlined"
				sx={{
					p: 2,
					mb: 2,
					"& > div": { maxWidth: "100%" },
					"& h1, & h2, & h3, & h4": { margin: "8px 0" },
					"& p": { margin: "4px 0" },
					"& table": {
						width: "100%",
						borderCollapse: "collapse",
						"& th, & td": {
							border: "1px solid #e0e0e0",
							padding: "8px",
							textAlign: "left",
						},
						"& th": { backgroundColor: "#f5f5f5" },
					},
				}}
				dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
			/>
			<Box sx={{ display: "flex", gap: 2 }}>
				<Button
					variant="contained"
					color="primary"
					onClick={onApprove}
					disabled={isApproving}
				>
					{isApproving ? "Saving..." : "Approve & Save"}
				</Button>
				<Button variant="outlined" onClick={onRegenerate}>
					Regenerate
				</Button>
				<Button variant="outlined" color="error" onClick={onCancel}>
					Cancel
				</Button>
			</Box>
		</Box>
	);
};

export default SmartProgramPreview;
